import { render, staticRenderFns } from "./ZoneReport.vue?vue&type=template&id=6c67ec6c&"
import script from "./ZoneReport.vue?vue&type=script&lang=js&"
export * from "./ZoneReport.vue?vue&type=script&lang=js&"
import style0 from "./ZoneReport.vue?vue&type=style&index=0&id=6c67ec6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QInnerLoading} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QInnerLoading})
